import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class RollReturnsController extends Controller {
  @service
  router;
}
